export default "__VITE_ASSET__CpGHZotR__"